// libs
import { useCallback, useContext } from "react";

// stores
import { AppContext } from "@store/context/App";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useSnackbarHandler() {
    const { showAlertMessage, hideAlertMessage } = useContext(AppContext);

    const showSnackbarMessage = useCallback((snackbarMessage): void => {
        showAlertMessage({ snackbarMessage });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const hideSnackbarMessage = useCallback((): void => {
        hideAlertMessage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { showSnackbarMessage, hideSnackbarMessage };
}

export default useSnackbarHandler;
